export const avatars = [
  {
    id: 1,
    image:
      'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/avatars/2.jpg',
  },
  {
    id: 2,
    image:
      'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/avatars/3.jpg',
  },
  {
    id: 3,
    image:
      'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/avatars/4.jpg',
  },
  {
    id: 4,
    image:
      'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/avatars/5.jpg',
  },
  {
    id: 5,
    image:
      'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/avatars/6.jpg',
  },
  {
    id: 6,
    image:
      'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/avatars/7.jpg',
  },
  {
    id: 7,
    image:
      'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/avatars/8.jpg',
  },
  {
    id: 8,
    image:
      'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/avatars/9.jpg',
  },
  {
    id: 10,
    image:
      'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/avatars/10.jpg',
  },
  {
    id: 11,
    image:
      'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/avatars/11.jpg',
  },
  {
    id: 12,
    image:
      'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/avatars/12.jpg',
  },
  {
    id: 13,
    image:
      'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/images/modules/avatars/1.jpg',
  },
];
